import { frontendURL } from '../../../../helper/URLHelper';

const clientReports = accountId => ({
  parentNav: 'client-reports',
  routes: ['client_reports'],
  menuItems: [
    {
      icon: 'list',
      label: 'TICKETS_MY_LIST',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/report-client/list`),
      toStateName: 'client_reports',
    },
  ],
});

export default clientReports;